import React from 'react';
import classNames from 'classnames';

import CheckboxCheck from 'components/Icon/CheckboxCheck';
import CheckboxUncheck from 'components/Icon/CheckboxUncheck';

const styles = {
  width: '1px',
  height: '1px',
  opacity: '0',
}

export default function CheckBox({ name, className, label, onChange, checked, disabled, children }) {
  const Icon = checked ? CheckboxCheck : CheckboxUncheck;
  return (
    <label className={classNames('block text-secondary text-sm font-sans ', className, {
      'cursor-not-allowed opacity-50': disabled,
      'cursor-pointer': !disabled,
    })}>
      <Icon width={30} height={30} className={classNames('inline-block fill-current', {
        'hover:text-default': !disabled,
      })} />
      <input name={name} disabled={disabled} type="checkbox" onChange={onChange} checked={checked} style={styles} /> {label || children}
    </label>
  );
}
